module.exports = __webpack_public_path__ + "img/CHATE.2a86645e.png";